export interface IcomxContactOwner {
  resourceType: string;
  resourceId: string;
}

export interface IcomxTelecomActionDetails extends Partial<IcomxContactOwner> {
  value?: string;
}

const SUPPORTED_ICOMX_RESOURCE_TYPES = new Set([
  'Patient',
  'Practitioner',
  'Organization',
  'RelatedPerson',
]);

export const getIcomxContactOwner = (resource: any): IcomxContactOwner | null => {
  if (
    !resource?.id ||
    !SUPPORTED_ICOMX_RESOURCE_TYPES.has(String(resource.resourceType ?? ''))
  ) {
    return null;
  }

  return {
    resourceType: String(resource.resourceType),
    resourceId: String(resource.id),
  };
};

export const getIcomxTelecomActionDetails = (
  preferredValue: string | null | undefined,
  preferredOwner: unknown,
  fallbackValue?: string | null,
  fallbackOwner?: unknown,
): IcomxTelecomActionDetails => {
  if (preferredValue) {
    return { value: preferredValue, ...getIcomxContactOwner(preferredOwner) };
  }

  if (fallbackValue) {
    return { value: fallbackValue, ...getIcomxContactOwner(fallbackOwner) };
  }

  return {};
};
